// "WHAT CAN YOU DO HERE?" — the answer as a card of four groups
// (DESIGN-COMPOSER-FOCUS-POPOVER-CONTEXT-INSPECT-1; the catalogue is
// functions/aiCapabilities.js). Drawn inside the assistant's block
// (AssistantThreadBlock, card type 'capabilities') in the sidebar and in the
// main thread's reading column.
//
// Each group: the line glyph on the house plate, its name and one line on
// what it means ("Changes I prepare for you — nothing runs until you approve
// it"); then its rows — the house menu row's look (MenuPanelItem) as plain
// buttons, each one a real ask, an action to prepare, a board to build or the
// start of Inspect & ask. A row's second line is its own description (an
// action's `describe`, a widget's), in the quiet ink. Groups are separated by
// rhythm, never strokes.
export const AssistantCapabilities = {
  // One column in the sidebar, two side by side at the main thread's board
  // width — the groups flow, nothing is cut.
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(min(18em, 100%), 1fr))',
  gap: 'A',
  minWidth: '0',
  childExtends: 'AssistantCapabilityGroup',
  childrenAs: 'state',
  children: (el, s) => {
    const g = s && s.groups
    const list = g && typeof g.parse === 'function' ? g.parse() : g
    return Array.isArray(list) ? list : []
  }
}

export const AssistantCapabilityGroup = {
  tag: 'section',
  ariaLabel: (el, s) => (s && s.title) || null,
  flow: 'y',
  gap: 'Y',
  minWidth: '0',

  CapHead: {
    flow: 'x',
    align: 'flex-start',
    gap: 'Z',
    minWidth: '0',
    padding: '0 X',
    CapPlate: {
      ariaHidden: 'true',
      display: 'flex',
      align: 'center center',
      flexShrink: '0',
      boxSize: 'glyphPlateXs',
      round: 'radiusPill',
      background: 'highlight',
      color: 'title-reversed',
      Icon: { name: (el, s) => (s && s.glyph) || 'lnAssistant', boxSize: 'iconSm' }
    },
    CapTitles: {
      flow: 'y',
      gap: 'W',
      minWidth: '0',
      CapTitle: {
        tag: 'h4',
        margin: '0',
        fontSize: 'Z1',
        fontWeight: '500',
        lineHeight: '1.3',
        color: 'title',
        text: (el, s) => (s && s.title) || ''
      },
      CapExplain: {
        tag: 'p',
        margin: '0',
        fontSize: 'Z',
        lineHeight: '1.35',
        color: 'caption',
        overflowWrap: 'anywhere',
        text: (el, s) => (s && s.explain) || ''
      }
    }
  },

  CapItems: {
    tag: 'ul',
    role: 'list',
    margin: '0',
    padding: '0',
    flow: 'y',
    gap: 'W',
    minWidth: '0',
    childExtends: 'AssistantCapabilityItem',
    childrenAs: 'state',
    children: (el, s) => {
      const it = s && s.items
      const list = it && typeof it.parse === 'function' ? it.parse() : it
      return Array.isArray(list) ? list : []
    }
  }
}

// One row: a list item holding the house row as a plain button (a menu row's
// look, a button's role — this is a list of actions in an answer, not a menu).
export const AssistantCapabilityItem = {
  tag: 'li',
  listStyle: 'none',
  minWidth: '0',
  MenuPanelItem: {
    role: null,
    flow: 'y',
    align: 'flex-start',
    gap: 'W',
    lineHeight: '1.35',
    CapLabel: {
      tag: 'span',
      minWidth: '0',
      overflowWrap: 'anywhere',
      text: (el, s) => (s && s.label) || ''
    },
    CapDescribe: {
      tag: 'span',
      hide: (el, s) => !(s && s.describe),
      minWidth: '0',
      fontSize: 'Z',
      color: 'caption',
      overflowWrap: 'anywhere',
      text: (el, s) => (s && s.describe) || ''
    },
    onClick: (e, el, s) => {
      e.preventDefault()
      e.stopPropagation()
      const row = s && typeof s.parse === 'function' ? s.parse() : s
      el.call('aiCapabilityRun', row)
    }
  }
}
